<template>
  <a
    :href="'/cases/' + locData.url_certain_lang"
    class="case__link-wrapper"
  >
    <div class="case__container">
      <div class="case__company-logo-wrapper">
        <img v-if="locData.image" :src="locData.image" alt="company logo" onerror="this.src='/dist/assets/front_white/img/svg/no-pic.svg';" class="case__company-logo" />
        <img v-else src="/dist/assets/front_white/img/svg/no-pic.svg" alt="" class="case__company-logo" />
      </div>
      <bimTextMain bold class="mb-3">{{ locData.title }}</bimTextMain>
      <BimTag :label="tagText" nohover />
      <bimTextHint class="mt-6 mb-2 case__company-result" bold>ИТОГ</bimTextHint>
      <bimTextMedium class="case__company-preview">{{ locData.itog }}</bimTextMedium>
    </div>
  </a>
</template>

<script>
import bimTextMain from "@bimlib/components/bimTextMain"
import bimTextHint from "@bimlib/components/bimTextHint"
import bimTextMedium from "@bimlib/components/bimTextMedium"
import BimTag from "@/athoms/BimTag"
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    bimTextMain,
    bimTextHint,
    bimTextMedium,
    BimTag,
  },
  computed: {
    /**
     * Возвращает версию в зависимости от языка(в будущем);
     */
    locData() {
      return this.data.lang_versions[1]
    },
    tagText() {
      return this.locData.tags_lang
    }
  },
}
</script>
